"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.commifiedRoundedNumberString = exports.numberStringRound = void 0;
var bignumber_1 = require("@ethersproject/bignumber");
var units_1 = require("@ethersproject/units");
function numberStringRound(value, precision) {
    var valueArray = value.split('.');
    if (valueArray.length == 2 && valueArray[1].length > precision) {
        // Has decimal points and need to round
        var decimal = parseFloat("0.".concat(value.split('.')[1]));
        var multiplier = Math.pow(10, precision || 0);
        var roundedDecimalComponent = Math.ceil(decimal * multiplier);
        if (roundedDecimalComponent / multiplier == 1) {
            return bignumber_1.BigNumber.from(valueArray[0]).add(bignumber_1.BigNumber.from(1)).toString();
        }
        else {
            return "".concat(valueArray[0], ".").concat((roundedDecimalComponent).toString().padStart(precision, '0'));
        }
    }
    else {
        return "".concat(value);
    }
}
exports.numberStringRound = numberStringRound;
function commifiedRoundedNumberString(value, precision) {
    return (0, units_1.commify)(numberStringRound(value, precision));
}
exports.commifiedRoundedNumberString = commifiedRoundedNumberString;
